import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {ASMainGamePickOptions, WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {IKarenGameData} from "./game/server/data/IKarenData";
import {KarenSoundConfig} from "./game/sound/KarenSoundConfig";
import {Karen} from "./game/Karen";
import {KarenGameMode} from "./game/server/KarenGameMode";
import {KarenGameAssets} from "./game/KarenGameAssets";

export class KarenPromoPanelConfig implements PromoPanelGameConfiguration {
    private featureName: string = "";

    constructor() {
    }


    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "Karen",
            hasActionSpin: true,
            graphics: {backgroundTextureName: KarenGameAssets.MAIN_GAME_BACKGROUND},
            mainGame: {
                header: () => Karen.apiPlugin.translations.translate("xBET"),
                options: [
                    {name: "NORMAL", id: 0, image: "xBetOff.png"},
                    {name: "BOOSTED_BET", id: 1, image: "xBetOn.png"}
                ],
                type: ASMainGamePickOptions.BOOSTED_BET
            },
            getParsedData: (response: IKarenGameData, bet: number, prevResponse: IKarenGameData): ASWinData => {
                const parsedData: ASWinData = {
                    totalWin: parseFloat(response.accumulatedRoundWin),
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpinTriggered(response),
                    totalSpinWinnings: this.getSpinWin(response, bet, prevResponse),
                    isBigWin: this.isBigWin(response),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: response.brokeTheBank,

                }
                return parsedData;
            }
        };
    }

    public onActionSpinPlaySound(trigger: ActionSpinSound): void {
        if (trigger == ActionSpinSound.WIN) {
            Karen.sound.playEffect(KarenSoundConfig.AS_WIN);
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            Karen.sound.playEffect(KarenSoundConfig.AS_WIN_BIG);
        }
    }

    private isBigWin(response: IKarenGameData): boolean {
        let win: number = parseFloat(response.totalSpinWinnings);

        if (response.wasFeatureBuy) {
            const betPrice = this.getBuyFeaturePrice(response);
            let winRatio: number = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }

        let winRatio: number = Helper.ceilToDecimals((win / parseFloat(response.playedBetValue)), 2);
        return winRatio >= 15;
    }

    private getBuyFeaturePrice(response: IKarenGameData): number {
        let betLevel = Karen.apiPlugin.freeBets.hasFreeBets() ? Karen.apiPlugin.freeBets.getBet() : Karen.apiPlugin.betLevel.getLevel();
        let price: number = parseFloat(response.playedBetValue) || parseFloat(betLevel);
        if (response.wasFeatureBuy) {
            for (let index = 0; index < Karen.model.initData.featureBuyTimesBetValue.length; index++) {
                if (Karen.model.initData.featureBuyTimesBetValue[index].name === Karen.model.buyFeatureName) {
                    price *= Karen.model.initData.featureBuyTimesBetValue[index].price;
                    break;
                }
            }
        }
        return price;
    }

    private getSpinWin(response: IKarenGameData, bet: number, prevData: IKarenGameData): number {
        return parseFloat(response.totalSpinWinnings);
    }

    private isFreeSpinTriggered(response: IKarenGameData): boolean {
        return response.mode === KarenGameMode.NORMAL && response.nextMode === KarenGameMode.FREESPIN;
    }

    private getFeatureName(response: IKarenGameData): string {
        let scatterCount: number = 0;
        if (response.reelsEnteringFreespin && response.mode === KarenGameMode.NORMAL && response.nextMode === KarenGameMode.FREESPIN) {
            for (let reelIdx: number = 0; reelIdx < response.reelsEnteringFreespin.length; reelIdx++) {
                for (let symIdx: number = 1; symIdx <= response.reelsEnteringFreespin[reelIdx].length - 2; symIdx++) {
                    if (response.reelsEnteringFreespin[reelIdx][symIdx] === "S") {
                        scatterCount++;
                    }
                }
            }
            scatterCount === 3 ? this.featureName = "COURSE MEAL VALUE" : this.featureName = "COURSE MEAL DELUXE";
        }
        if (response.mode === KarenGameMode.NORMAL && response.nextMode === KarenGameMode.NORMAL) {
            this.featureName = "";
        }
        if (response.mode === KarenGameMode.FREESPIN) {
            for (let reelIdx: number = 0; reelIdx < response.reels.length; reelIdx++) {
                for (let symIdx: number = 1; symIdx <= response.reels[reelIdx].length - 2; symIdx++) {
                    if (response.reels[reelIdx][symIdx] === "S") {
                        this.featureName = "COURSE MEAL DELUXE";
                    }
                }
            }
        }
        return this.featureName;
    }

    private isRoundComplete(response: IKarenGameData): boolean {
        return ([KarenGameMode.FREESPIN, KarenGameMode.NORMAL].indexOf(response.nextMode) > -1);
    }

    private isBonusEnd(response: IKarenGameData): boolean {
        return ((response.nextMode === KarenGameMode.NORMAL) && (response.mode === KarenGameMode.FREESPIN));
    }


}